define('common',['jquery', 'bootstrap', 'cookie'], function($){
  $(document).ready(function() {

      $.fn.loopNext = function(selector) {
        var selector = selector || '';
        return this.next(selector).length ? this.next(selector) : this.siblings(selector).addBack(selector).first();
      }

      $.fn.loopPrev = function(selector) {
        var selector = selector || '';
        return this.prev(selector).length ? this.prev(selector) : this.siblings(selector).addBack(selector).last();
      }

      $.isMobileSite = function() {
        return window.location.hostname.substr(0, 2) == 'm.' || window.location.hostname.substr(0, 10) == 'staging-m.';
      }

      $(document).on('show.bs.modal', function (e) {
        $('.overlay').hide();
        $('#inner').css('position', 'static');
      });
      $(document).on('hide.bs.modal', function (e) {
        $('.overlay').show();
        $('#inner').css('position', 'relative');
      });

      $('#cookie-consent-close').click(function() {
        $(this).parent().parent().parent().remove();
        $.cookie('mccp', '1', {path: '/', expires: 365});
      });

      $('.beta').tooltip();

  });

});
